import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../firebase';
import { extractAuthors } from "./utils";
import "./ProjectsWriting.css";

function ProjectWritingInputs() {
  const { state } = useLocation();
  const initialValues = state || {};

  const [user] = useAuthState(auth);
  const navigate = useNavigate();

  const [showAddForm, setShowAddForm] = useState(false);
  const [newPub, setNewPub] = useState({ title: "", year: "", citation: "" });

  const [idea_idx, setIdeaIdx] = useState(null);
  const [titleInput, setTitleInput] = useState("");
  const [methodInput, setMethodInput] = useState("");
  const [priorityInput, setPriorityInput] = useState("");
  const [WPList, setWPList] = useState([]);
  const [keywordsList, setKeywordsList] = useState([""]);
  const [publicationList, setPublicationList] = useState([]);
  const [projectDuration, setProjectDuration] = useState([]);
  const [selectedManagementMethod] = useState("Agile");

  useEffect(() => {
    setIdeaIdx(initialValues.idea_idx || null);
    setTitleInput(initialValues.title || "");
    setMethodInput(initialValues.method || "");
    setPriorityInput(initialValues.priority || "");
    setWPList(initialValues.wpList || []);
    setKeywordsList(initialValues.keywordsList || []);
    setPublicationList(initialValues.publicationList || []);
    setProjectDuration(initialValues.projectDuration || []);
  }, [initialValues]);

  if (!user) return null;

  const autoGrow = (element) => {
    if (element) {
      element.style.height = "auto";
      element.style.height = element.scrollHeight + "px";
    }
  };

  const validateForm = () => {
    if (methodInput.length < 2500 || methodInput.length > 15000) {
      alert("Çözüm önerisi 2500 - 15000 karakter arasında olmalıdır.");
      return false;
    }
    if (!titleInput.trim()) {
      alert("Proje başlığı girilmelidir.");
      return false;
    }
    if (!WPList.length) {
      alert("İş paketleri girilmelidir.");
      return false;
    }
    if (!publicationList.length) {
      alert("En az 1 ön fizibilite yayını girilmelidir.");
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      navigate('/sections_writing', {
        state: {
          user_idx: user.uid,
          idea_idx,
          title: titleInput,
          method: methodInput,
          keywordsList,
          priority: priorityInput,
          wpList: WPList,
          publicationList: publicationList,
          projectDuration: projectDuration
        }
      });
    }
  };

  const addWP = () => {
    setWPList([
      ...WPList,
      { work_package_title: "", start_month: 1, duration: 1 }
    ]);
  };

  const handleWPChange = (index, field, value) => {
    const updated = [...WPList];
    updated[index][field] = field === "work_package_title" ? value : parseInt(value);
    setWPList(updated);
  };

  const removeWP = (index) => {
    setWPList(WPList.filter((_, i) => i !== index));
  };

  const handleSavePublication = () => {
    if (!newPub.title || !newPub.year || !newPub.citation) {
      alert("Lütfen tüm alanları doldurunuz.");
      return;
    }
    setPublicationList([...publicationList, newPub]);
    setNewPub({ title: "", year: "", citation: "" });
    setShowAddForm(false);
  };

  const removePublication = (index) => {
    const updated = [...publicationList];
    updated.splice(index, 1);
    setPublicationList(updated);
  };

  return (
    <div className="app-container">
      <div
        onClick={() => navigate("/")}
        style={{ cursor: "pointer", display: "inline-block" }}
      >
        <img
          src="/logo_light_unified_noBG.png"
          alt="Logo"
          className="top-logo"
        />
      </div>
      <div className="input-screen">
        <div className="input-section">
          <div className="input-header">
            <h2>Yeni Proje: "{titleInput}"</h2>
          </div>
          <div className="input-subheader">
            <h4>Proje Hazırlama Sürecini Başlatmak için Aşağıdaki Bölümlerin Doğruluğunu Kontrol Ediniz ve Düzenleyiniz.</h4>
          </div>

          <div className="input-content">
            <h3>Proje Başlığı</h3>
            <textarea
              value={titleInput}
              onChange={(e) => setTitleInput(e.target.value)}
              placeholder="Proje başlığı giriniz."
              className="input-box"
            />
          </div>

          <div className="input-content">
            <h3>Çözüm Önerisi</h3>
            <textarea
              value={methodInput}
              onChange={(e) => { setMethodInput(e.target.value); autoGrow(e.target); }}
              ref={(el) => el && autoGrow(el)}
              placeholder="En az 2500 karakterlik çözüm önerisi giriniz."
              className="input-box"
            />
          </div>

          <div className="input-content">
            <h3>Öncelikli Alan</h3>
            <textarea
              value={priorityInput}
              onChange={(e) => { setPriorityInput(e.target.value); autoGrow(e.target); }}
              ref={(el) => el && autoGrow(el)}
              placeholder="Çağrı metnindeki öncelikli alanı giriniz."
              className="input-box"
            />
          </div>

          <div className="input-content">
            <h3>İş Paketleri</h3>
            <table className="wp-table">
              <thead>
                <tr>
                  <th>İş Paketi Açıklaması</th>
                  <th>Başlangıç Ayı</th>
                  <th>Süre (Ay)</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {WPList.map((wpItem, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="text"
                        value={wpItem.work_package_title}
                        onChange={(e) => handleWPChange(index, "work_package_title", e.target.value)}
                        placeholder={`WP ${index + 1}`}
                        className="input-field"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={wpItem.start_month}
                        onChange={(e) => handleWPChange(index, "start_month", e.target.value)}
                        className="input-field"
                        min={1}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={wpItem.duration}
                        onChange={(e) => handleWPChange(index, "duration", e.target.value)}
                        className="input-field"
                        min={1}
                      />
                    </td>
                    <td>
                      <div className="delete-btn-wrapper">
                        <button
                          className="delete-btn small"
                          onClick={() => removeWP(index)}
                          title="İş Paketini Kaldır"
                        >
                          ❌
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="add-btn-wrapper">
              <button onClick={addWP} className="add-pub-btn small">
                İş Paketi Ekle
              </button>
            </div>
          </div>

          <div className="input-content">
            <h3>Ön Fizibilite Çalışmaları</h3>
            <table className="publication-table">
              <thead>
                <tr>
                  <th>Başlık</th>
                  <th>Yıl</th>
                  <th>Yazarlar</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {publicationList.map((pub, index) => (
                  <tr key={index}>
                    <td>{pub.title || "—"}</td>
                    <td style={{ textAlign: "center" }}>{pub.year || "—"}</td>
                    <td>{extractAuthors(pub.citation)}</td>
                    <td>
                      <div className="delete-btn-wrapper">
                        <button
                          className="delete-btn small"
                          onClick={() => removePublication(index)}
                          title="Yayını kaldır"
                        >
                          ❌
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {showAddForm ? (
              <div className="add-pub-form">
                <input
                  type="pub-text"
                  placeholder="Başlık"
                  value={newPub.title}
                  onChange={(e) => setNewPub({ ...newPub, title: e.target.value })}
                  className="input-field"
                />
                <input
                  type="pub-number"
                  placeholder="Yıl"
                  value={newPub.year}
                  onChange={(e) => setNewPub({ ...newPub, year: parseInt(e.target.value) })}
                  className="input-field"
                />
                <input
                  type="pub-text"
                  placeholder="Yazarlar (citation)"
                  value={newPub.citation}
                  onChange={(e) => setNewPub({ ...newPub, citation: e.target.value })}
                  className="input-field"
                />
                <div className="button-container">
                  <button onClick={handleSavePublication} className="add-pub-btn small">Kaydet</button>
                  <button onClick={() => setShowAddForm(false)} className="add-pub-cancel-btn small">İptal</button>
                </div>
              </div>
            ) : (
              <div className="add-btn-wrapper">
                <button onClick={() => setShowAddForm(true)} className="add-pub-btn small">
                  Yayın Ekle
                </button>
              </div>
            )}
          </div>

          <button onClick={handleSubmit} className="submit-btn">
            YAPAY ZEKA İLE PROJE YAZIMINI BAŞLAT
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProjectWritingInputs;
